import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DiscussionModel, DiscussionModelData } from "../../common/models/discussion-model";
import { User } from "../../common/models/user";
import { castToModel } from "../../common/providers/utils-provider.service";
import { Organization } from "../../common/models/organization";
import { ChatDiscussion } from "../../common/models/chat-discussion";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({
  providedIn: 'root'
})
export class DiscussionService {
    public populateDiscussionsEvent: EventEmitter<any> = new EventEmitter<any>();
    public discussionDeletedEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private apiService: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    /**
     * Find all discussions for a user
     *
     * @param user
     */
    public findAllByUser(user: User): Observable<DiscussionModel[]> {
      return this.apiService.call('get', `users/${user.id}/chat/discussions`, {}, this.currentUser.getAccessToken())
      .pipe(
        map((discussions: DiscussionModelData[]) => {
          return DiscussionModel.fromApiList(discussions);
        })
      );
    }

    public findDiscussionsBetweenTwoUsers(fromUserId: number, toUsersId: number[], organization: Organization) {
      return this.apiService.call('post', `users/${fromUserId}/chat/discussion`, {
        to: toUsersId,
        organization: organization.id,
      },
      this.currentUser.getAccessToken()
        ).pipe(
        map((discussions: DiscussionModelData[]) => {
          return DiscussionModel.fromApiList(discussions);
        })
      );
    }

    public save(user: User, organization: Organization, participantIds: number[], discussionName: string | null = null): Observable<DiscussionModel> {
      return this.apiService.call('post', `users/${user.id}/chat/discussions`, {
        participants: participantIds,
        name: discussionName,
        organization: organization.id,
      },
      this.currentUser.getAccessToken()
      ).pipe(
        map((discussions: DiscussionModelData) => {
          return DiscussionModel.fromApi(discussions);
        })
      );
    }

    public markAsSeen(user: User, discussion: DiscussionModel): Observable<DiscussionModel> {
      return this.apiService.call('post', `users/${user.id}/chat/discussions/mark-as-seen`, {
        discussion: discussion.id
      },
        this.currentUser.getAccessToken()
      ).pipe(
        map((discussions: DiscussionModelData) => {
          return DiscussionModel.fromApi(discussions);
        })
      );
    }

    public delete(user: User, discussionId: number): Observable<ChatDiscussion> {
      return this.apiService.call('delete', `users/${user.id}/chat/discussions/${discussionId}`, {}, this.currentUser.getAccessToken());
    }

    public countUnseenMessagesByUser(user: User): Observable<number> {
      return this.apiService.call('get', `users/${user.id}/chat/discussions/unseen-messages`, {}, this.currentUser.getAccessToken())
        .pipe(
          map((response: any) => {
            return response.unseenMessages;
          })
        );
    }

    public findOneById(user: User, id: number): Observable<DiscussionModel> {
      return this.apiService.call('get', `users/${user.id}/chat/discussions/${id}`,{}, this.currentUser.getAccessToken())
      .pipe(
        map((discussions: DiscussionModelData) => {
          return DiscussionModel.fromApi(discussions);
        })
      );
    }
}
